import type { ReactNode, SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  options: SelectOption[];
  placeholder?: string;
}

export function Select({
  id,
  label,
  hint,
  error,
  options,
  placeholder,
  className,
  ...rest
}: SelectProps) {
  const inputId = id ?? rest.name;
  return (
    <div className={styles.field}>
      {label ? (
        <label className={styles.fieldLabel} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <select
        id={inputId}
        className={cn(styles.control, error && styles.controlError, className)}
        aria-invalid={error ? true : undefined}
        {...rest}
      >
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      {error ? <div className={styles.fieldError}>{error}</div> : null}
      {!error && hint ? <div className={styles.fieldHint}>{hint}</div> : null}
    </div>
  );
}
